import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreCommonModule } from '@core/common.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { RoleManagmentUpdateComponent } from './role-managment-update/role-managment-update.component';
import { NgbDatepickerModule, NgbModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { ProductCreateSerialnoComponent } from './product-create-serialno/product-create-serialno.component';
import { ProductMovementCreateComponent } from './product-movement-create/product-movement-create.component';
import { SubProductCreateComponent } from './sub-product-create/sub-product-create.component';
import { TransactionCreateDilaogComponent } from './transaction-create-dilaog/transaction-create-dilaog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { Ng2FlatpickrModule } from 'ng2-flatpickr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TransactionUpdateDialogComponent } from './transaction-update-product-dialog/transaction-update-dialog.component';
import { TransactionUpdateComponent } from './transaction-update-dialog/transaction-update.component';
import { TransactionPrivateCodeConfirmedDialogComponent } from './transaction-private-code-confirmed-dialog/transaction-private-code-confirmed-dialog.component';
import { CreateVaultDialogComponent } from './create-vault-dialog/create-vault-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateVaultMovementComponent } from './create-vault-movement/create-vault-movement.component';
import { FileUploadDialogComponent } from './file-upload-dialog/file-upload-dialog.component';
import { CreatePersonComponent } from './create-person/create-person.component';
import { NgxMaskModule } from 'ngx-mask';
import { SendpdfDialogComponent } from './sendpdf-dialog/sendpdf-dialog.component';
import { CreateVaultCompanyMovementComponent } from './create-vault-company-movement/create-vault-company-movement.component';
import { CreateActionComponent } from './create-action/create-action.component';
import { QuillModule } from 'ngx-quill';
import { BlockUIModule } from 'ng-block-ui';
import { SendPrintTransactionComponent } from './send-print-transaction/send-print-transaction.component';
import { CreateCompanyComponent } from './create-company/create-company.component';
import { CreateProductComponent } from './create-product/create-product.component';
import { CreateWorkerDialogComponent } from './create-worker-dialog/create-worker-dialog.component';
import { PersonLeaveComponent } from './person-leave/person-leave.component';
import { PayrollComponent } from './payroll/payroll.component';
import { PersonPointDialogComponent } from './person-point-dialog/person-point-dialog.component';
import { CreateBrandModelComponent } from './create-brand-model/create-brand-model.component';
import { CreateDeviceDialogComponent } from './create-device-dialog/create-device-dialog.component';
import { DeviceDeliveryDialogComponent } from './device-delivery-dialog/device-delivery-dialog.component';
import { UpdateDeviceDialogComponent } from './update-device-dialog/update-device-dialog.component';
import { ReferenceTransactionsComponent } from './reference-transactions/reference-transactions.component';
import { ProcedureDialogComponent } from './procedure-dialog/procedure-dialog.component';
import { DeviceClassDialogComponent } from './device-class-dialog/device-class-dialog.component';
import { CreateDeliveryDeviceComponent } from './create-delivery-device/create-delivery-device.component';
import { DeliveryUpdateDialogComponent } from './delivery-update-dialog/delivery-update-dialog.component';
import { DeliveryDeviceUpdateDialogComponent } from './delivery-device-update-dialog/delivery-device-update-dialog.component';
import { DialogReferenceDeviceMovementComponent } from './dialog-reference-device-movement/dialog-reference-device-movement.component';
import { CalibartionCreateDilaogComponent } from './calibartion-create-dilaog/calibartion-create-dilaog.component';
import { CreateEnvironmentalConditionComponent } from './create-environmental-condition/create-environmental-condition.component';
import { UpdateCalibrationDialogComponent } from './update-calibration-dialog/update-calibration-dialog.component';
import { CreateCertificateDialogComponent } from './create-certificate-dialog/create-certificate-dialog.component';
import { CertificateReservationDialogComponent } from './certificate-reservation-dialog/certificate-reservation-dialog.component';

@NgModule({
  declarations: [
    RoleManagmentUpdateComponent,
    ProductCreateSerialnoComponent,
    ProductMovementCreateComponent,
    SubProductCreateComponent,
    TransactionCreateDilaogComponent,
    ConfirmDialogComponent,
    TransactionUpdateDialogComponent,
    TransactionUpdateComponent,
    TransactionPrivateCodeConfirmedDialogComponent,
    CreateVaultDialogComponent,
    CreateVaultMovementComponent,
    FileUploadDialogComponent,
    CreatePersonComponent,
    SendpdfDialogComponent,
    CreateVaultCompanyMovementComponent,
    CreateActionComponent,
    SendPrintTransactionComponent,
    CreateCompanyComponent,
    CreateProductComponent,
    CreateWorkerDialogComponent,
    PersonLeaveComponent,
    PayrollComponent,
    PersonPointDialogComponent,
    CreateBrandModelComponent,
    CreateDeviceDialogComponent,
    DeviceDeliveryDialogComponent,
    UpdateDeviceDialogComponent,
    ReferenceTransactionsComponent,
    ProcedureDialogComponent,
    DeviceClassDialogComponent,
    CreateDeliveryDeviceComponent,
    DeliveryUpdateDialogComponent,
    DeliveryDeviceUpdateDialogComponent,
    DialogReferenceDeviceMovementComponent,
    CalibartionCreateDilaogComponent,
    CreateEnvironmentalConditionComponent,
    UpdateCalibrationDialogComponent,
    CreateCertificateDialogComponent,
    CertificateReservationDialogComponent,
  ],
  imports: [
    CommonModule,
    CoreCommonModule,
    NgSelectModule,
    Ng2FlatpickrModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    QuillModule.forRoot(),
    BlockUIModule.forRoot(),
    NgbTimepickerModule,
    NgbDatepickerModule,
    NgbModule
  ]
})
export class DialogsModule { }
